import { CourseMarkdown } from "@/components/storyboard/CourseMarkdown";
import type {
  TextStructuredContentData,
  TextTitledBodyData,
} from "@/types/storyboard";
import { Text } from "@/components/storyboard/text/Text";
import { titledBodyMarkdown } from "@/components/storyboard/text/utils/titledBodyMarkdown";

interface Props {
  data: TextStructuredContentData | TextTitledBodyData | string;
}

export const TextStructured = ({ data }: Props) => {
  if (typeof data === "string") {
    return <Text text={data} />;
  }
  if ("sections" in data) {
    return (
      <div className="prose max-w-full">
        {data.title && <h2>{data.title}</h2>}
        {data.introduction && (
          <CourseMarkdown>{data.introduction}</CourseMarkdown>
        )}
        {data.sections?.map((section, i) => (
          <div key={i}>
            {section.heading && <h3>{section.heading}</h3>}
            <CourseMarkdown>{section.text}</CourseMarkdown>
          </div>
        ))}
      </div>
    );
  }
  return (
    <div className="prose max-w-full">
      {data.title && <h2>{data.title}</h2>}
      <CourseMarkdown>{titledBodyMarkdown(data)}</CourseMarkdown>
    </div>
  );
};
